/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, createContext, useContext, useEffect, useState} from 'react'

export interface PageLink {
  title: string
  path: string
  isActive: boolean
  isSeparator?: boolean
}

interface PageDescriptionInterface {
  icon: string,
  description: string
  svgClassName: string
}

export interface PageDataContextModel {
  pageTitle?: string
  setPageTitle: (_title: string) => void
  pageDescription?: PageDescriptionInterface
  setPageDescription: (state: PageDescriptionInterface) => void
  pageBreadcrumbs?: Array<PageLink>
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void
}

const PageDataContext = createContext<PageDataContextModel>({
  setPageTitle: (_title: string) => {
  },
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => {
  },
  setPageDescription: (state: PageDescriptionInterface) => {
  },
})

const PageDataProvider: React.FC = ({children}) => {
  const [pageTitle, setPageTitle] = useState<string>('')
  const [pageDescription, setPageDescription] = useState<PageDescriptionInterface>({
    icon: '', description: '', svgClassName: ''
  })
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([])
  const value: PageDataContextModel = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
  }
  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

type Props = {
  infos?: PageDescriptionInterface
  breadcrumbs?: Array<PageLink>
}

const PageTitle: FC<Props> = ({children, infos, breadcrumbs}) => {
  const {setPageTitle, setPageDescription, setPageBreadcrumbs} = usePageData()
  useEffect(() => {
    if (children) {
      setPageTitle(children.toString())
    }
    return () => {
      setPageTitle('')
    }
  }, [children])

  useEffect(() => {
    if (infos) {
      setPageDescription(infos)
    }
    return () => {
      setPageDescription({icon: '', description: '', svgClassName: ''})
    }
  }, [infos])

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs)
    }
    return () => {
      setPageBreadcrumbs([])
    }
  }, [breadcrumbs])

  return <></>
}

const PageDescription: React.FC<PageDescriptionInterface> = ({icon, description, svgClassName}) => {
  const {setPageDescription} = usePageData()
  useEffect(() => {

    setPageDescription({icon, description, svgClassName})

    // if (children) {
    //   setPageDescription(children.toString())
    // }
    // return () => {
    //   setPageDescription('')
    // }
  }, [])
  return <></>
}

export {PageDescription, PageTitle, PageDataProvider, usePageData}
